package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.UserRepository
import com.clany.backoffice.domain.repository.KeycloakRepository
import com.clany.backoffice.model.UserResponse

import dev.zacsweers.metro.Inject

@Inject
class UpdateUserUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(user: UserResponse): Result<UserResponse> {
        val request = com.clany.backoffice.data.repository.UpdateUserRequest(
            id = user.id,
            firstName = user.firstName,
            lastName = user.lastName,
            type = user.type,
            locale = user.locale,
            linkedMemberId = user.linkedMemberId,
            pictureUrl = user.pictureUrl,
            shouldUpdateTyc = user.shouldUpdateTyc
        )

        // Update Backend (Mongo). The backend now handles Keycloak sync.
        return userRepository.updateUser(request)
    }
}
